<template>
    <div id="content" class="app-content" ref="myDiv">
        <div class="box">
            <b-row>
                <b-col cols="12" md="12" class="mb-3 d-flex SrcBox">
                    <div class="Src-Box Data-Box Type-Box" @mouseenter="centerType = false" @mouseleave="centerType = true">
                        <div class="Src-Box title_item">Center Type</div>
                        <div class="Src-Name-Box">
                            <div class="src-name src-name01 src-type">{{centerTypeName}}</div>
                            <img alt="" src="../assets/images/downward01.png" v-if="centerType" class="" @click="getType()">
                            <img alt="" src="../assets/images/downward02.png" v-if="!centerType" class="" @click="getType()">
                        </div>
                        <div class="Filter-Box Filter-Box01" v-if="!centerType">
                            <div v-for="(item,i) in allType" :key="i" @click="getTypeItem(i,item)">{{item.center_category_name}}</div>
                        </div>
                    </div>
                    <div class="Src-Box Data-Box" @mouseenter="StateSwitch = false" @mouseleave="StateSwitch = true" v-if="items !== ''">
                        <div class="Src-Box title_item">Center</div>
                        <div class="Src-Name-Box">
                            <div class="src-name src-center title" @mouseenter="titleF = titleT" @mouseleave="titleF = false" >{{currentCenterName}}</div>
                            <img src="../assets/images/downward01.png" v-if="StateSwitch" class="" @click="getSwitch()">
                            <img src="../assets/images/downward02.png" v-if="!StateSwitch" class="" @click="getSwitch()">
                        </div>
                        <div class="Filter-Box" v-if="!StateSwitch">
                            <div v-for="(item,i) in items" :key="i" @click="getItem(i,item)">{{item.center_name}}</div>
                        </div>
                    </div>
                    <div class="Src-Box Data-Box" @mouseenter="StateData =false" @mouseleave="StateData =true">
                        <div class="Src-Box title_item">Year</div>
                        <div class="Src-Name-Box">
                            <div class="src-name src-name01 src-name03 ">{{this.year}}</div>
                            <img src="../assets/images/downward01.png" v-if="StateData" class="" @click="getData()">
                            <img src="../assets/images/downward02.png" v-if="!StateData" class="" @click="getData()">
                        </div>
                        <div class="Filter-Box " v-if="!StateData">
                            <div v-for="(data,i) in years" :key="i" @click="getItem01(i,data)">{{data}}</div>
                        </div>
                    </div>
                    <div class="Src-Box Data-Box Data-Box03" @mouseenter="StateMonths =false" @mouseleave="StateMonths =true">
                        <div class="Src-Box title_item">Installment</div>
                        <div class="Src-Name-Box">
                            <div class="src-name src-name01 src-name03 src-name04">{{selectedMonthName}}</div>
                            <img src="../assets/images/downward01.png" v-if="StateMonths" class="" @click="getMonths()">
                            <img src="../assets/images/downward02.png" v-if="!StateMonths" class="" @click="getMonths()">
                        </div>
                        <div class="Filter-Box " v-if="!StateMonths">
                            <div v-for="(data,i) in months" :key="i" @click="getItem03(i,data)">{{data.hk}}</div>
                        </div>
                    </div>
                    <div class="Src-Box Name-Box" @mouseenter="StateName =false" @mouseleave="StateName =true">
                        <div class="Src-Box title_item">Single Class Option</div>
                        <div class="Src-Name-Box">
                            <div class="src-name src-name01 src-name02 ">{{names[0].name}}</div>
                            <img alt="" src="../assets/images/downward01.png" v-if="StateName" class="" @click="getName()">
                            <img alt="" src="../assets/images/downward02.png" v-if="!StateName" class="" @click="getName()">
                        </div>
                        <div class="Filter-Box Filter-Box02" v-if="!StateName">
                            <div v-for="(name,i) in names" :key="i" @click="getItem02(i,name)">{{name.name}}</div>
                        </div>
                    </div>
                    <div class="confirm-box">
                        <button class="confirm-btn" @click="confirmData">Confirm</button>
                    </div>
                </b-col>

                <!-- 首行图表区域 -->
                <div class="now_box" style="">
                    <!--图表1 接口getRevenue-->
                    <b-col cols="12" lg="3" class="topT">
                        <div class="now_time">*Data as of {{nowTime}} </div>
                        <!--                        <div class="now_time">The "Received Revenue" "Outstanding Tuition Free" report, and "New Student Revenue" report are updated in real-time.</div>-->
                        <div class="mon_sice"><span><span style="color: crimson">*</span>$</span>{{this.recData[0] | MoneyFormat}}</div>
                        <span class="mon_span">Received Revenue</span>
                        <div class="No_data" v-if="NoRecData">
                            <div class="No_item">
                                <img alt="" src="./images/无数据.png">
                                <p>Data will be ready in 7th of each month.</p>
                            </div>
                        </div>
                        <div id="chart1" ref="myElement1">
                            <!--                            <apexchart type="area" :height="this.nowHei" :options="OptionsRec" :series="seriesRec"></apexchart>-->
                            <apexchart type="bar" :height="this.nowHei" :options="optionsRec" :series="seriesRec"></apexchart>
                        </div>
                    </b-col>
                    <!--图表2 接口getOutstandingPayment-->
                    <b-col cols="12" lg="3" class="topT">
                        <div class="mon_sice"><span><span style="color: crimson">*</span>$</span>{{this.recData[1] | MoneyFormat}}</div>
                        <span class="mon_span">Outstanding Tuition Fee</span>
                        <div class="No_data" v-if="NoOutData">
                            <div class="No_item">
                                <img alt="" src="./images/无数据.png">
                                <p>Data will be ready in 7th of each month.</p>
                            </div>
                        </div>
                        <div id="chart2" ref="myElement2">
                            <!--                            <apexchart type="area" :height="this.nowHei" :options="OptionsOtf" :series="seriesOtf"></apexchart>-->
                            <apexchart type="bar" :height="this.nowHei" :options="optionsOtf" :series="seriesOtf"></apexchart>
                        </div>
                    </b-col>
                    <!--图表3 接口getNewStudentRevenue-->
                    <b-col cols="12" lg="3" class="topT">
                        <div class="mon_sice"><span><span style="color: crimson">*</span>$</span>{{this.recData[2] | MoneyFormat}}</div>
                        <span class="mon_span">New Student Revenue</span>
                        <div class="No_data" v-if="NoNewData">
                            <div class="No_item">
                                <img alt="" src="./images/无数据.png">
                                <p>{{No_Data}}</p>
                            </div>
                        </div>
                        <div id="chart3" ref="myElement3">
                            <!--                            <apexchart type="area" :height="this.nowHei" :options="OptionsNsr" :series="seriesNsr"></apexchart>-->
                            <apexchart type="bar" :height="this.nowHei" :options="optionsNsr" :series="seriesNsr"></apexchart>
                        </div>
                    </b-col>
                </div>
                <!-- 第二行图表区域 -->

                <!--图表4 接口getReportSheet1-->
                <b-col cols="12"  lg="6"  sm="12" xs="12" class="SrcItem">
                    <b-card title=" " class="b_card">
                        <div v-if="!NoData1" class="course d-flex justify-content-center align-items-center" style="">Course Distribution</div>
                        <div class="No_data" v-if="NoData1">
                            <div class="No_item">
                                <img alt="" src="./images/无数据.png">
                                <p>{{No_Data}}</p>
                            </div>
                        </div>
                        <apexchart v-else type="pie" :height="this.pieH" :options="this.optionsPie" :series="this.seriesPie"></apexchart>
                    </b-card>
                </b-col>

                <!--图表5 接口getReportSheet3-->
                <b-col cols="12" lg="6"  sm="12" xs="12" class="SrcItem">
                    <b-card title=" "  class="b_card b_card01">
                        <div class="No_data" v-if="NoData3">
                            <div class="No_item">
                                <img alt="" src="./images/无数据.png">
                                <p>{{No_Data}}</p>
                            </div>
                        </div>
                        <apexchart v-else type="line" :height="this.pieH01" :options="this.optionsLine" :series="this.seriesLine"></apexchart>
                    </b-card>
                </b-col>

                <!-- 第三行图表区域 -->

                <!--图表6 接口getReportSheet2-->
                <b-col cols="12" class="SrcItem SrcItem01">
                    <b-card title=" " style="min-height: 395px">
                        <div class="No_data" v-if="NoData2" style="width: 99%">
                            <div class="No_item">
                                <img alt="" src="./images/无数据.png">
                                <p>{{No_Data}}</p>
                            </div>
                        </div>
                        <apexchart v-else type="bar" :height="this.pieH" :options="this.optionsColumn" :series="this.seriesColumn"></apexchart>
                        <div class="title_box">
                            <div class="title_item01" v-for="(titleItem,i) in Column_categories" :key="i">
                                <span  @mouseover="a=i" @mouseout="a=-1">{{titleItem}}</span>
                                <div class="title_block" v-show="i === a">{{titleItem}}</div>
                            </div>
                        </div>
                    </b-card>
                </b-col>

                <!--      mark          -->
                <!-- 第四行图表区域 -->
                <!--图表7 接口getReportSheet4-->
                <b-col cols="12" md="6" class="SrcItem hiden_in" style="position: relative">
                    <div class="chart_with_menu">
                        <b-card title="" id="chart" style="min-height: 395px">
                            <div class="No_data" v-if="NoData4">
                                <div class="No_item">
                                    <img alt="" src="./images/无数据.png">
                                    <p>{{No_Data}}</p>
                                </div>
                            </div>
                            <apexchart v-else type="line" height="350px" :options="this.optionsChart"  :series="this.seriesChart" ref="myChart"></apexchart>
                        </b-card>
                        <right-drop-menu :years="years" :diff="true" :courseList="courseList" @confirmData="changeSheet4Data"/>
                    </div>
                </b-col>

                <!--图表8 接口getReportSheet5-->
                <b-col cols="12" md="6" class="SrcItem hiden_in" style="position: relative">
                    <div class="chart_with_menu chart_menu_tight">
                        <b-card title="" id="chart" style="min-height: 395px">
                            <div class="No_data" v-if="NoData5">
                                <div class="No_item">
                                    <img alt="" src="./images/无数据.png">
                                    <p>{{No_Data}}</p>
                                </div>
                            </div>
                            <apexchart v-else type="line" height="350px" :options="this.optionsRevenue" :series="this.seriesRevenue"></apexchart>
                        </b-card>
                        <right-drop-menu :years="years" @confirmData="changeSheet5Data"/>
                    </div>
                </b-col>
                <!-- 第五行图表区域 -->
                <!--图表9 接口getReportSheet6-->
                <b-col cols="12" md="6" class="SrcItem" style="position: relative">
                    <div class="chart_with_menu chart_menu_inset">
                        <b-card title="" id="chart chart9" style="min-height: 330px">
                            <div class="No_data" v-if="NoData6">
                                <div class="No_item">
                                    <img alt="" src="./images/无数据.png">
                                    <p>{{No_Data}}</p>
                                </div>
                            </div>
                            <apexchart v-else type="area" height="300px" :options="this.optionsArea" :series="this.seriesArea"></apexchart>
                        </b-card>
                        <right-drop-menu :years="years" @confirmData="changeSheet6Data"/>
                    </div>
                </b-col>

                <!--图表10 接口getReportSheet7-->
                <b-col cols="12" md="6" class="SrcItem" style="position: relative">
                    <div class="chart_with_menu chart_menu_inset">
                        <b-card title="" id="chart" style="min-height: 330px">
                            <div class="No_data" v-if="NoData7">
                                <div class="No_item">
                                    <img alt="" src="./images/无数据.png">
                                    <p>{{No_Data}}</p>
                                </div>
                            </div>
                            <apexchart v-else type="line" height="300px" :options="this.optionsTooltips" :series="this.seriesTooltips"></apexchart>
                        </b-card>
                        <right-drop-menu :years="years" @confirmData="changeSheet7Data"/>
                    </div>
                </b-col>

                <!-- 第六行图表区域 -->
                <!--图表11 接口getRetentionRate-->
                <b-col cols="12" md="6" class="SrcItem ProsBox" style="position: relative">
                    <div class="chart_with_menu chart_menu_wide">
                        <b-card title="" id="chart" style="min-height: 330px">
                            <div class="No_data" v-if="NoData8">
                                <div class="No_item">
                                    <img alt="" src="./images/无数据.png">
                                    <p>{{No_Data}}</p>
                                </div>
                            </div>
                            <apexchart v-else type="bar" height="300px" :options="this.optionsPros" :series="this.seriesPros"></apexchart>
                        </b-card>
                        <right-drop-menu :years="years" @confirmData="changeRetentionData"/>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import RightDropMenu from "./component/RightDropMenu.vue"
export default {
    name:'Home',
    components: {
        RightDropMenu
    },
    data () {
        return {
            curYear: new Date().getFullYear(),
            courseList: [],
            chartBarData: {},
            chartLineData:{},
            chartRingData:{},
            //实时图表1
            recData:[],
            OptionsRec: {},
            TotalRevenue:[],
            RevenueTime:[],
            seriesRec:[],
            optionsRec:{},
            //实时图表2
            OptionsOtf: {},
            TotalOtf:[],
            OtfTime:[],
            seriesOtf:[],
            optionsOtf:{},
            //实时图表3
            OptionsNsr: {},
            TotalNsr:[],
            NsrTime:[],
            seriesNsr: [],
            optionsNsr:{},
            //饼状图
            seriesPie: [],
            optionsPie: {},
            apexColumn:{},
            //柱状图
            seriesColumn: [],
            optionsColumn: {},
            apexLine:{},
            //折线图
            seriesLine: [],
            optionsLine: {},
            //柱状图|折线图01
            seriesChart: [],
            optionsChart: {},
            //柱状图|折线图02
            optionsRevenue:{},
            seriesRevenue:[],
            //折状图
            optionsArea:{},
            seriesArea:[],
            //折线图
            optionsTooltips:{},
            seriesTooltips:[],
            //堆积柱状图
            optionsPros:{},
            seriesPros:[],
            StateSwitch:true,
            items:"All Center",
            StateData:true,
            years:[],
            StateMonths:true,
            months:[
                {cn:"1",hk:"January"},
                {cn:"2",hk:"February"},
                {cn:"3",hk:"March"},
                {cn:"4",hk:"April"},
                {cn:"5",hk:"May"},
                {cn:"6",hk:"June"},
                {cn:"7",hk:"July"},
                {cn:"8",hk:"August"},
                {cn:"9",hk:"September"},
                {cn:"10",hk:"October"},
                {cn:"11",hk:"November"},
                {cn:"12",hk:"December"},
            ],
            isMonths:[
                {cn:"1",hk:"January"},
                {cn:"2",hk:"February"},
                {cn:"3",hk:"March"},
                {cn:"4",hk:"April"},
                {cn:"5",hk:"May"},
                {cn:"6",hk:"June"},
                {cn:"7",hk:"July"},
                {cn:"8",hk:"August"},
                {cn:"9",hk:"September"},
                {cn:"10",hk:"October"},
                {cn:"11",hk:"November"},
                {cn:"12",hk:"December"},
            ],
            StateName:true,
            names:[{
                name:"With Single Class Enrollment",
                id:1
            },{
                name:"Without Single Class Enrollment",
                id:2
            }],
            allType:[],
            //柱状图|折线图01
            average_num:[],
            total_num:[],
            time_num:[],
            //柱状图|折线图02
            average_revenue:[],
            total_revenue:[],
            time_revenue:[],
            //折状图
            average_total_number_of_student:[],
            total_number_of_student:[],
            average_name:"Average Number of The Group",
            total_name:"Center",
            time_number:[],
            //折线图
            average_total_enrollments:[],
            total_enrollments:[],
            time_enrollments:[],
            drop_out_rate:[],
            retenstion_rate:[],
            rate_time:[],
            api:"https://gamejava.monkeytree.com.hk/vue/",
            center_id:"72",
            item:"2022-1",
            singleTypeId:"1",
            center_category_id:12,
            centerTypeName:'',
            pendingInitialReport:false,
            No_Data:'No Data Available.',
            token:localStorage.getItem('token'),
            year:new Date().getFullYear(),
            nowTime:'',
            month:"1",
            optionsPie_length:"0",
            pieH:"450px",
            nowHei:"190px",
            pieH01:"450px",
            srceenWidth:null,
            myWidth:null,
            NoRecData:false,
            NoOutData:false,
            NoNewData:false,
            NoData:false,
            NoData1:false,
            NoData2:false,
            NoData3:false,
            NoData4:false,
            NoData5:false,
            NoData6:false,
            NoData7:false,
            NoData8:false,
            title_item:'',
            titleF:false,
            titleT:false,
            centerType:true,
            zeroize:false,
            a:"",
            recDate:'',
            outDate:'',
            nsrDate:'',
            element1:[],
            // 饼状图数据
            courseName:[],
            courseNum:[],
            course_name:[],
            course_num:[],
            str:[],
            // 折线图数据
            lineData:[],
            lineData01:[],
            lineData02:[],
            lineData03:[],
            lineData04:[],
            Months01:[],
            Months02:[],
            Months03:[],
            categories:[],
            categories01:[],
            maxNum:'',
            maxArr:[],
            // 柱状图数据
            ColumnData:[],
            ColumnData01:[],
            newArr04:[],
            Column_categories:[],
            Column_categories01:[],
            maxClumn_num:[],
            maxClumn_num01:[],
        }
    },
    computed: {
        currentCenter() {
            if (!Array.isArray(this.items) || !this.items.length) {
                return null;
            }
            return this.items[1] || this.items[0];
        },
        currentCenterName() {
            return this.currentCenter && this.currentCenter.center_name ? this.currentCenter.center_name : '';
        },
        selectedMonthName() {
            const current = this.months.find(item => String(item.cn) === String(this.month))
            if (current) {
                return current.hk
            }
            return this.months[0] ? this.months[0].hk : ''
        }
    },
    watch: {
        center_category_id:function (i,e){
            this.center_category_id = i;
            this.getAllCenter();
        },
        items:function (i){
            const center = Array.isArray(i) ? (i[1] || i[0]) : null;
            if (center && center.center_id != null) {
                this.center_id = center.center_id;
            }
            this.items = i;
        },
        center_id:function (i,e) {
            this.center_id = i;
            if(i === 79 || i === 115 || i === 117 || i === 131 || i === 124){
                this.titleT = true;
            }else {
                this.titleT = false;
            }
        },
        item:function (i,e) {
            this.item = i;
            // this.getAllCenter( );
            // this.getReportSheet();
        },
        year:function (i,e) {
            this.year = i;
            this.getSevenAgo();
            if (this.months[0]) {
                this.month = this.months[0].cn
            }
        },
        month:function (i,e) {
            this.month = i;
            // this.getAllCenter( );
            // this.getReportSheet();
        },
        singleTypeId:function (i,e) {
            this.singleTypeId = i;
            // this.getAllCenter( );
            // this.getReportSheet();
        },
        title_item:function(i,e){
            this.title_item = i;
        },
        srceenWidth:function (i,e) {
            if(i <= 1600){
                this.nowHei = "170px";
                this.pieH = "300px";
                this.pieH01 = "350px";
            }
            if(i <= 1440){
                this.nowHei = "150px"
            }
            if(i <= 1190){
                this.nowHei = "135px"
            }
            if(i <= 1024){
                this.pieH = "400px";
                this.pieH01 = "450px"
                this.nowHei = "120px"

            }
            if(i <= 991){
                this.nowHei = "230px"
            }
            if(i <= 425){
                this.pieH = "350px";
                this.nowHei = "120px"
            }
            if(i <= 375){
                this.nowHei = "150px"
            }
            // console.log(i,this.nowHei)
        },
    },

    mounted() {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();
        for(var i = year; i >= 2019; i--){
            this.years.push(i);
        }
        this.getCenterCategory();

        // 判断屏幕尺寸
        this.srceenWidth = document.body.clientWidth;
        window.onresize = () => {
            return (() => {
                this.srceenWidth = document.body.clientWidth;
            })()
        };
        this.getSevenAgo()
    },

    created() {
        // 获取当前日期
        var today = new Date();

        // 获取前一天的日期
        var yesterday = new Date(today);
        // yesterday.setDate(today.getDate() - 1);
        // 当天
        yesterday.setDate(today.getDate());

        // 格式化日期
        var year = yesterday.getFullYear();
        var month = yesterday.getMonth() + 1;
        var day = yesterday.getDate();

        // 打印前一天的日期（格式为年-月-日）
        this.nowTime = year + '-' + month + '-' + day;

        this.$axios.get( this.api + "getUser?" + "token=" + this.token,{
            withCredentials: true
        }).then(function (resp){
            const istoken = resp.data.success;
            // localStorage.setItem('token', resp.data.token);
            // console.log("getUser==>",resp)
            if(resp.data.success !== "true"){
                localStorage.removeItem("token");
                this.$router.push({path: '/login'});
            }else {
                localStorage.setItem('isToken',istoken);
                localStorage.setItem('token', resp.data.token);
            }
        })


    },
    methods: {
        getSevenAgo() {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth();
            // 当前月份的第七天
            const seventhDay = new Date(year, month, 7);
            // 当前选择年份跟当前年份做比较，判断前日期在第七天之前不能显示当时月份，超过才显示当前月份
            if(this.year === year) {
                if(today < seventhDay){
                    this.months = this.isMonths.slice(0,month);
                }else {
                    this.months = this.isMonths.slice(0,month+1);
                }
            }else {
                this.months = this.isMonths;
            }
        },
        // 封装请求接口的方法
        async fetchData (apiEntPoint, params) {
            try {
                const resp = await this.$axios.get( apiEntPoint, {params} )
                return resp.data
            } catch (e){
                console.error('API Error:', e);
                return null; //没有数据
            }
        },
        confirmData(){
            this.getReportSheet()
        },
        // 统一的请求数据的方法
        async getReportSheet() {
            this.onclickTrue=true;
            var that = this;
            //展示loadding页面
            let loader = this.$loading.show({});

            await that.$axios.get( that.api + "getUser?" + "token=" + that.token,{
                withCredentials: true
            }).then(function (resp){
                if(resp.data.success === "false"){
                    localStorage.removeItem("token");
                    that.$router.push({path: '/login'});
                    // 隐藏loadding页面
                    loader.hide();
                }
            })
            const params = {
                center_id: this.center_id,
                year: this.year,
                month: this.month,
                singleTypeId: this.singleTypeId,
                token: this.token,
                center_category_id: this.center_category_id
            }
            const readData = async (url) => {
                const resp = await this.fetchData(url, params)
                return resp && resp.data != null ? resp.data : null
            }
            const courseData = await readData(this.api + 'getReportSheet4AllCourse')
            this.courseList = Array.isArray(courseData) ? courseData : []

            // 实时展示数据
            const revenueData = await readData(this.api + 'getRevenue')
            if(revenueData && revenueData.length){
                this.TotalRevenue = revenueData.map(item => item.total_revenue)
                this.RevenueTime = revenueData.map(item => `${item.year} - ${item.month < 10 ? '0' : ''}${item.month}`)
                this.recDate = revenueData[revenueData.length - 1]?.total_revenue || 0
                this.NoRecData = false
            }else{
                this.NoRecData = true
            }
            // 获取未付款数据
            const outstandingData = await readData(this.api + 'getOutstandingPayment')
            if(outstandingData && outstandingData.length){
                this.TotalOtf = outstandingData.map(item => item.outstanding_total)
                this.OtfTime = outstandingData.map(item => `${item.year} - ${item.month < 10 ? '0' : ''}${item.month}`)
                this.outDate =  outstandingData[outstandingData.length - 1]?.outstanding_total || 0
                this.NoOutData = false
            }else{
                this.NoOutData = true
            }
            // 获取新学生收入数据
            const newStudentRevenueData = await readData(this.api + 'getNewStudentRevenue')
            if(newStudentRevenueData && newStudentRevenueData.length) {
                this.TotalNsr = newStudentRevenueData.map(item => item.new_student_revenue)
                this.NsrTime = newStudentRevenueData.map(item => `${item.year} - ${item.month < 10 ? '0' : ''}${item.month}`)
                this.nsrDate = newStudentRevenueData[newStudentRevenueData.length -1]?.new_student_revenue || 0
                this.NoNewData = false
            }else {
                this.NoNewData = true
            }

            // 图1饼图数据
            const pieData = await readData(this.api + 'getReportSheet1')
            if(pieData){
                this.NoData1 = pieData.length === 0;
                this.courseName = pieData.map(item => item.master_course_name)
                this.courseNum = pieData.map(item => item.num)
                this.getCourse(this.courseName,that.courseNum)
            }else{
                this.NoData1 = false
            }
            // 图2柱状数据
            const barData = await readData(this.api + "getReportSheet2")
            if(barData){
                this.NoData2 = barData.length < 3
                const uniqueCourses = {}
                const newArr02 = barData.reduce((acc,item) => {
                    if(!uniqueCourses[item.master_course_name]){
                        // 筛选课程
                        uniqueCourses[item.master_course_name] = true
                        acc.push(item);
                        // 补全所有
                        ['new','drop','active','return'].forEach(type => {
                            if(item.type !== type) acc.push({...item, num: 0, type})
                        })
                    }
                    return acc
                }, [])
                // 更新数量
                barData.forEach(item => {
                    newArr02.forEach(nums => {
                        if(nums.master_course_name === item.master_course_name && nums.type === item.type){
                            nums.num = item.num
                        }
                    })
                })
                // 按照字母顺序排序并调用方法
                this.getReportSheet2(barData, newArr02.sort((a,b) => (a.master_course_name || '').localeCompare(b.master_course_name || '')))
            }else{
                this.NoData2 = true
            }

            // 图3折线图数据
            const brokenLineData = await readData(this.api + 'getReportSheet3')
            if(Array.isArray(brokenLineData) && brokenLineData.length > 0){
                console.log(brokenLineData)
                const newArr = []
                const uniqueCourses = {}
                let newArr01 = []
                const years = []
                let numTwo = ''
                brokenLineData.forEach(item => {
                    this.maxArr.push(item.num)
                    // 判断 分别拆分三个月份数组数据
                    // 当前月份
                    if(parseInt(this.month) === item.month) this.lineData01.push(item)
                    // 上一个月
                    const lastMonth = (this.month - 1 + 12) % 12 || 12;
                    if (lastMonth === item.month) this.lineData02.push(item)
                    // 前两个月
                    const lastTwoMonth = (this.month - 2 + 12) % 12 || 12
                    if(lastTwoMonth === item.month) this.lineData03.push(item)
                    // 判断时间条件
                    this.zeroize = (this.year === item.year && this.month === item.month)
                    // 筛选归类课程
                    if(!uniqueCourses[item.master_course_id]){
                        newArr.push({...item})
                        uniqueCourses[item.master_course_id] = true
                        // item.num = ',' + item.num
                    }else{
                        newArr.forEach(ss => {
                            if(ss.master_course_id === item.master_course_id) {
                                ss.num += ',' + item.num
                                ss.year += ',' + item.year
                                ss.month += ',' + item.month
                            }
                        })
                    }

                    // 筛选出时间
                    const monthKey = `${item.year}-${item.month}`
                    // console.log(monthKey)
                    if(!newArr01.includes(monthKey)){
                        newArr01.push(monthKey)
                        years.push(item.year);
                    }
                })
                // 针对2019年特定情况调整月份
                if(this.year === 2019){
                    if(this.month === '9') newArr01 = ['2019-7','2019-8','2019-9']
                    if(this.month === '10') newArr01 = ['2019-8','2019-9','2019-10']
                }
                while (newArr01.length < 3){
                    const lastMonth = newArr01[0]
                    const [lastYear, lastMonthNum] = lastMonth.split('-').map(Number)
                    const newMonth = (lastMonthNum - 1) <= 0 ? 12 : lastMonthNum - 1
                    const newYear = (lastMonthNum - 1) <= 0 ? lastYear - 1 : lastYear
                    newArr01.unshift(`${newYear}-${newMonth}`)
                    numTwo = 2
                }
                this.categories = newArr01.sort()
                this.NoData3 = newArr01.length < 1
                this.getNum(this.lineData01,this.lineData02,this.lineData03,newArr.sort((a,b) => (a.master_course_name || '').localeCompare(b.master_course_name || '')),this.maxArr,numTwo,this.zeroize);
            }else{
                this.NoData3 = true
            }

            // 图4柱状折线数据
            const columnarPolylineOne = await readData(this.api + 'getReportSheet4')
            // 处理图4柱状折线数据的方法
            this.processAndSortData(columnarPolylineOne)
            // 图5柱状折线数据
            const columnarPolylineTwo = await readData(this.api + 'getReportSheet5')
            // 处理图5柱状折线数据的方法
            this.processAndSortRevenueData(columnarPolylineTwo)

            //图6折状图
            const PolylineOne = await readData(this.api + 'getReportSheet6')
            this.processAndSortTNSData(PolylineOne)

            //图7折状图
            const PolylineTwo = await readData(this.api + 'getReportSheet7')
            this.processAndSortTNsData(PolylineTwo)
            // 最后一个图表接口
            const RetentionRateData = await readData(this.api + 'getRetentionRate')
            this.processAndSortRetentionData(RetentionRateData)
            await this.$axios.get("./chartsData.json").then(response => {
                this.chartBarData = response.data.chartBarData;
                this.chartLineData = response.data.chartLineData;
                this.chartRingData = response.data.chartRingData;

                // 默认页面展示该中心数据
                this.recData = response.data.recData.data;
                this.recData[0] = this.recDate;
                this.recData[1] = this.outDate;
                this.recData[2] = this.nsrDate;
                this.OptionsRec = response.data.recDates.OptionsRec;
                this.seriesRec = response.data.recDates.seriesRec;
                this.seriesRec[0].data = this.TotalRevenue;
                this.OptionsRec.xaxis.categories = this.RevenueTime;

                this.OptionsOtf = response.data.OtfDates.OptionsOtf;
                this.seriesOtf = response.data.OtfDates.seriesOtf;
                this.seriesOtf[0].data = this.TotalOtf;
                this.OptionsOtf.xaxis.categories = this.OtfTime;

                this.OptionsNsr = response.data.NsrDates.OptionsNsr;
                this.seriesNsr = response.data.NsrDates.seriesNsr;
                this.seriesNsr[0].data = this.TotalNsr;
                this.OptionsNsr.xaxis.categories = this.NsrTime;


                // 默认页面展示该中心数据
                this.optionsPie = response.data.apexPie.optionsPie;
                this.seriesPie = this.str;
                this.optionsPie.labels = this.course_name;
                // this.optionsPie.tooltip = this.optionsPieTextA.tooltip;
                // console.log(this.str);


                this.seriesLine = this.lineData;
                this.optionsLine = response.data.apexLine.optionsLine;
                // 默认页面展示该中心数据
                this.optionsLine.xaxis.categories = this.categories;
                this.optionsLine.yaxis.max = this.maxNum;
                // console.log(this.lineData);


                // this.apexColumn = response.data.apexColumn;
                this.seriesColumn = this.ColumnData;
                this.optionsColumn = response.data.apexColumn.optionsColumn;
                // 默认页面展示该中心数据
                // this.optionsColumn.tooltip = this.optionsColumnA.tooltip;
                this.optionsColumn.yaxis.max = this.maxClumn_num;
                // this.Column_categories 用在插件上会倾斜字体
                // this.optionsColumn.xaxis.categories = this.Column_categories;
                // console.log(this.Column_categories);


                this.optionsChart = response.data.apexChart.optionsChart;
                this.seriesChart = response.data.apexChart.seriesChart;

                this.seriesChart[1].data = this.average_num;
                this.seriesChart[0].data = this.total_num;
                this.optionsChart.labels = this.time_num;
                this.setSheet4CourseName(this.courseList[0] && this.courseList[0].master_course_name);
                // console.log('图表4数据',this.average_num,this.total_num,this.time_num);

                // 默认页面展示该中心数据
                // this.optionsChart.tooltip = this.optionsColumnA.tooltip;

                this.seriesRevenue = response.data.apexRevenue.seriesRevenue;
                this.optionsRevenue = response.data.apexRevenue.optionsRevenue;
                this.seriesRevenue[1].data = this.average_revenue;
                this.seriesRevenue[0].data = this.total_revenue;
                this.optionsRevenue.labels = this.time_revenue;
                // console.log('图表5数据:',this.average_revenue,this.total_revenue,this.time_revenue);
                // 默认页面展示该中心数据
                // this.optionsRevenue.title.text = this.optionsRevenueText;
                // this.optionsRevenue.tooltip = this.optionsRevenueA.tooltip;

                this.optionsArea = response.data.apexArea.optionsArea;
                this.seriesArea = response.data.apexArea.seriesArea;
                this.seriesArea[1].data = this.average_total_number_of_student;
                this.seriesArea[1].name = this.average_name;
                this.seriesArea[0].data = this.total_number_of_student;
                this.seriesArea[0].name = this.total_name;
                this.optionsArea.xaxis.categories = this.time_number;
                // console.log('图表6数据:',this.average_total_number_of_student,this.total_number_of_student,this.time_number);
                // 默认页面展示该中心数据
                // this.optionsArea.title.text = this.optionsAreaText;

                this.optionsTooltips = response.data.apexTooltips.optionsTooltips;
                this.seriesTooltips = response.data.apexTooltips.seriesTooltips;
                this.seriesTooltips[1].data = this.average_total_enrollments;
                this.seriesTooltips[0].data = this.total_enrollments;
                this.optionsTooltips.xaxis.categories = this.time_enrollments;
                // console.log('图表7数据:',this.average_total_enrollments,this.total_enrollments,this.time_enrollments);
                // console.log(this.time_enrollments);
                // 默认页面展示该中心数据
                // this.optionsTooltips.title.text = this.optionsTooltipsText;

                this.optionsPros = response.data.apexPros.optionsPros;
                this.seriesPros = response.data.apexPros.seriesPros;
                this.seriesPros[0].data = this.retenstion_rate;
                this.seriesPros[1].data = this.drop_out_rate;
                this.optionsPros.xaxis.categories = this.rate_time;
                this.setRetentionPercentLabels();
                // console.log('图表8数据:',this.average_total_enrollments,this.total_enrollments,this.time_enrollments);
                // console.log(this.time_enrollments);
                // 默认页面展示该中心数据
                // this.optionsTooltips.title.text = this.optionsTooltipsText;

                this.optionsRec = response.data.apexRec.optionsRec;
                this.seriesRec = response.data.apexRec.seriesRec;
                this.seriesRec[0].data = this.TotalRevenue;
                this.optionsRec.xaxis.categories = this.RevenueTime;

                this.optionsOtf = response.data.apexOtf.optionsOtf;
                this.seriesOtf = response.data.apexOtf.seriesOtf;
                this.seriesOtf[0].data = this.TotalOtf;
                this.optionsOtf.xaxis.categories = this.OtfTime;

                this.optionsNsr = response.data.apexNsr.optionsNsr;
                this.seriesNsr = response.data.apexNsr.seriesNsr;
                this.seriesNsr[0].data = this.TotalNsr;
                this.optionsNsr.xaxis.categories = this.NsrTime;


                // 隐藏loadding页面
                loader.hide();
            });

        },
        processAndSortData(data) {
            if (!data || data.length < 1) {
                this.NoData4 = true
                return
            }
            this.NoData4 = false

            const average_num = []
            const total_num = []
            const time_num = []

            const sortData = data.map(item => ({
                ...item,
                month: Number(item.month),
                year: Number(item.year)
            })).sort((a, b) => a.year !== b.year ? a.year - b.year : a.month - b.month)

            sortData.forEach(({average_num: avg, num, year, month}) => {
                average_num.push(avg)
                total_num.push(num)
                time_num.push(`${year}-${month}`)
            })

            this.average_num = average_num
            this.total_num = total_num
            this.time_num = time_num
        },
        processAndSortRevenueData(data) {
            if (!data || data.length < 1) {
                this.NoData5 = true
                return
            }
            this.NoData5 = false;
            const average_revenue = []
            const total_revenue = []
            const time_revenue = []

            data.forEach(item => {
                average_revenue.push(item.average_revenue)
                total_revenue.push(item.total_revenue)
                time_revenue.push(`${item.year}-${item.month}`)
            });

            // 补全长度为3
            while (average_revenue.length < 3) average_revenue.unshift(0)
            while (total_revenue.length < 3) total_revenue.unshift(0)
            while (time_revenue.length < 3) {
                const [lastYear, lastMonthNum] = time_revenue[0].split('-').map(Number)
                const newMonth = lastMonthNum - 1 <= 0 ? 12 : lastMonthNum - 1
                const newYear = lastMonthNum - 1 <= 0 ? lastYear - 1 : lastYear
                time_revenue.unshift(`${newYear}-${newMonth}`)
            }
            this.average_revenue = average_revenue
            this.total_revenue = total_revenue
            this.time_revenue = time_revenue
        },
        processAndSortTNSData(data) {
            if (!data || data.length < 1) {
                this.NoData6 = true
                return
            }
            this.NoData6 = false
            const average_total_number_of_student = []
            const total_number_of_student = []
            const time_number = []
            data.forEach(item => {
                average_total_number_of_student.push(item.average_total_number_of_student)
                total_number_of_student.push(item.total_number_of_student)
                time_number.push(`${item.year}-${item.month}`)
                // 根据条件判断显示的名称
                if (item.average_total_number_of_student < item.total_number_of_student) {
                    this.average_name = "Average Number of The Group"
                    this.total_name = "Center"
                } else {
                    this.average_name = "Center"
                    this.total_name = "Average Number of The Group"
                }
            })
            while (average_total_number_of_student.length < 3) average_total_number_of_student.unshift(0)
            while (total_number_of_student.length < 3) total_number_of_student.unshift(0)
            while (time_number.length < 3) {
                const [lastYear, lastMonthNum] = time_number[0].split('-').map(Number)
                const newMonth = lastMonthNum - 1 <= 0 ? 12 : lastMonthNum - 1
                const newYear = lastMonthNum - 1 <= 0 ? lastYear - 1 : lastYear
                time_number.unshift(`${newYear}-${newMonth}`)
            }
            this.average_total_number_of_student = average_total_number_of_student;
            this.total_number_of_student = total_number_of_student;
            this.time_number = time_number;
        },
        processAndSortTNsData(data) {
            if (!data || data.length < 1) {
                this.NoData7 = true
                return
            }
            this.NoData7 = false
            const average_total_enrollments = []
            const total_enrollments = []
            const time_enrollments = []
            data.forEach(item => {
                average_total_enrollments.push(item.average_total_enrollments)
                total_enrollments.push(item.total_enrollments)
                time_enrollments.push(`${item.year}-${item.month}`)
            })
            while (average_total_enrollments.length < 3) average_total_enrollments.unshift(0)
            while (total_enrollments.length < 3) total_enrollments.unshift(0)
            while (time_enrollments.length < 3) {
                const [lastYear, lastMonthNum] = time_enrollments[0].split('-').map(Number)
                const newMonth = lastMonthNum - 1 <= 0 ? 12 : lastMonthNum - 1
                const newYear = lastMonthNum - 1 <= 0 ? lastYear - 1 : lastYear
                time_enrollments.unshift(`${newYear}-${newMonth}`)
            }
            this.average_total_enrollments = average_total_enrollments
            this.total_enrollments = total_enrollments
            this.time_enrollments = time_enrollments
        },
        processAndSortRetentionData(data) {
            if (!data || data.length < 1) {
                this.NoData8 = true
                return
            }
            this.NoData8 = false
            const drop_out_rate = []
            const retention_rate = []
            const rate_time = []
            data.forEach(item => {
                drop_out_rate.push(item.total_number_of_student - item.active_student_number)
                retention_rate.push(item.active_student_number)
                rate_time.push(`${item.year}-${item.month}`)
            })
            while (drop_out_rate.length < 3) drop_out_rate.unshift(0)
            while (retention_rate.length < 3) retention_rate.unshift(0)
            while (rate_time.length < 3) {
                const [lastYear, lastMonthNum] = rate_time[0].split('-').map(Number)
                const newMonth = lastMonthNum - 1 <= 0 ? 12 : lastMonthNum - 1
                const newYear = lastMonthNum - 1 <= 0 ? lastYear - 1 : lastYear
                rate_time.unshift(`${newYear}-${newMonth}`)
            }
            this.drop_out_rate = drop_out_rate
            this.retenstion_rate = retention_rate
            this.rate_time = rate_time
        },
        retentionPercentFormatter(val, opts) {
            const series = opts && opts.w && opts.w.config ? opts.w.config.series : []
            const point = opts ? opts.dataPointIndex : 0
            const values = (series || []).map(item => {
                const raw = item && item.data ? item.data[point] : 0
                const num = Number(raw)
                return isNaN(num) ? 0 : num
            })
            const total = values.reduce((sum, num) => sum + num, 0)
            if (!total) {
                return ''
            }
            const percents = values.map(num => Math.round(num / total * 100))
            const drift = 100 - percents.reduce((sum, num) => sum + num, 0)
            if (percents.length) {
                percents[percents.length - 1] += drift
            }
            const percent = percents[opts.seriesIndex]
            return (percent == null ? 0 : percent) + '%'
        },
        setRetentionPercentLabels() {
            const formatter = this.retentionPercentFormatter
            this.optionsPros = {
                ...this.optionsPros,
                dataLabels: {
                    enabled: true,
                    formatter,
                    style: {
                        colors: ['#fff']
                    }
                },
                tooltip: {
                    ...(this.optionsPros.tooltip || {}),
                    y: {
                        formatter
                    }
                }
            }
        },

        getNum: function (array01, array02, array03, newArray, maxArr, numTwo, zeroize) {
            // num 最大值
            this.maxNum = Math.max(...maxArr) + 5;
            this.lineData01 = [];
            this.lineData02 = [];
            this.lineData03 = [];
            this.maxArr = [];
            this.lineData04 = []
            newArray.forEach(item => {
                const numArray = item.num.toString().split(',')
                if (numArray.length === 1) {
                    switch (this.month - item.month) {
                        case 0:
                            item.num = '0,0,' + item.num
                            break;
                        case 1:
                            item.num = '0,' + item.num + ',0'
                            break;
                        case 2:
                            item.num = item.num + ',0,0'
                            break;
                        default:
                            break;
                    }
                } else if (numArray.length === 2) {
                    if (!array01.some(arrItem => arrItem.master_course_name === item.master_course_name)) item.num = item.num + ',0'
                    if (!array02.some(arrItem => arrItem.master_course_name === item.master_course_name)) item.num = item.num.split(',')[0] + ',0,' + item.num.split(',')[1]
                    if (!array03.some(arrItem => arrItem.master_course_name === item.master_course_name)) item.num = '0,' + item.num
                }
                if (item.num && typeof item.num === 'string') {
                  this.lineData04.push({
                    name: item.master_course_name,
                    data: item.num.split(',')
                  });
                } else {
                  console.warn('Invalid or missing item.num:',item.num);
                }
            })
            this.lineData = this.lineData04
        },

        getCourse: function (names, nums) {
            var that = this;
            if (names.length !== 0 && nums.length !== 0) {
                that.NoData = false;
                that.course_name = names;
                that.course_num = nums;
                that.courseName = [];
                that.courseNum = [];
            } else {
                // 该名称接口没数据直接清零
                that.NoData = true;
                that.course_name = [];
                that.course_num = [];
                that.str = [];
            }
            // 饼图数据转化
            if (that.course_num.length !== 0) {
                that.str = that.course_num;
                that.str = that.str.map(function (item, index, array) {
                    return item - 0;
                });
            }
            // console.log(that.str,that.course_num )
        },

        getReportSheet2: function (newData, newArr02) {
            const newArr03 = []
            const obj03 = {}
            newArr02.forEach((item) => {
                // 筛选归类课程
                if (!obj03[item.type]) {
                    newArr03.push(item);
                    obj03[item.type] = item;
                } else {
                    newArr03.forEach((nums) => {
                        if (nums.type === item.type) {
                            nums.num = nums.num + "," + item.num
                        }
                    })
                }
            });
            // 按字母排序
            // newArr03.sort((a,b) => {
            //      return a.type.localeCompare(b.type)
            //  });
            newArr03.forEach(item => {
                if (item.type === "new") {
                    this.ColumnData01.push({
                        id: "1",
                        name: "New Student",
                        data: item.num.split(",").map(function (item, index, array) {
                            return item - 0;
                        })
                    })
                }
                if (item.type === "return") {
                    this.ColumnData01.push({
                        id: "2",
                        name: "Return Student",
                        data: item.num.split(",").map(function (item, index, array) {
                            return item - 0;
                        })
                    })
                }
                if (item.type === "active") {
                    this.ColumnData01.push({
                        id: "3",
                        name: "Continue Student",
                        data: item.num.split(",").map(function (item, index, array) {
                            return item - 0;
                        })
                    })
                }
                if (item.type === "drop") {
                    this.ColumnData01.push({
                        id: "4",
                        name: "Withdrawn Student",
                        data: item.num.split(",").map(function (item, index, array) {
                            return item - 0;
                        })
                    })
                }
            });
            this.ColumnData = this.ColumnData01;
            this.ColumnData01 = [];

            this.ColumnData.forEach(item => {
                item.data.forEach(ss => {
                    this.maxClumn_num01.push(ss)
                })
            });
            //  最大值
            this.maxClumn_num = Math.max(...this.maxClumn_num01) + 5;
            this.maxClumn_num01 = [];
            // console.log(this.maxClumn_num);

            // 排序
            newArr02.map(item => {
                this.Column_categories01.push(item.master_course_name)
            });
            this.Column_categories = [...new Set(this.Column_categories01)];
            this.Column_categories01 = [];
            // this.getAxios();

            // this.Column_categories.forEach((item)=>{
            //     console.log( item.split("").slice(0,10).join("") + "...");
            //     this.Column_categories02.push(item.split("").slice(0,10).join("") + "...")
            // });
            // this.Column_categories =  this.Column_categories02;
            // this.Column_categories02 = [];
            // console.log(this.Column_categories);
        },

        getCenterCategory: function (item) {
            var that = this;
            that.$axios.get(that.api + "getCenterCategory?" + "token=" + that.token).then(function (resp) {
                const list = resp.data && resp.data.data;
                that.allType = Array.isArray(list) ? list : [];
                const first = that.allType[0];
                if (!first) {
                    return;
                }
                that.centerTypeName = first.center_category_name;
                that.pendingInitialReport = true;
                if (that.center_category_id === first.center_category_id) {
                    that.getAllCenter();
                } else {
                    that.center_category_id = first.center_category_id;
                }
            })
        },

        getAllCenter: function (i) {
            var that = this;
            that.$axios.get(that.api + "getAllCenter?" + "token=" + that.token + '&' + "center_category_id=" + that.center_category_id).then(function (resp) {
                const list = resp.data && resp.data.data;
                that.items = Array.isArray(list) ? list : [];
                const center = that.items[1] || that.items[0];
                if (center && center.center_id != null) {
                    that.center_id = center.center_id;
                }
                const nameEl = document.querySelector('.src-center');
                if (nameEl && center) {
                    nameEl.innerHTML = center.center_name || '';
                }
                if (that.pendingInitialReport) {
                    that.pendingInitialReport = false;
                    that.getReportSheet();
                }
            })
        },

        getSwitch: function () {
            this.StateSwitch = !this.StateSwitch;
        },

        getItem: function (i, item) {
            this.StateSwitch = !this.StateSwitch;
            document.querySelector('.src-center').innerHTML = item.center_name;
            this.title_item = item.center_name;
            this.center_id = item.center_id;
            // console.log( this.center_id )
        },

        getData: function () {
            this.StateData = !this.StateData
        },

        getItem01: function (i, data) {
            this.year = data;
            this.StateData = !this.StateData;
        },

        getMonths: function () {
            this.StateMonths = !this.StateMonths
        },

        getItem03: function (i, data) {
            this.month = data.cn;
            this.StateMonths = !this.StateMonths;
        },

        getName: function () {
            this.StateName = !this.StateName
        },

        getItem02: function (i, name) {
            this.StateName = !this.StateName;
            this.singleTypeId = name.id;
            document.querySelector('.src-name02').innerHTML = name.name;
            // console.log(this.singleTypeId)
        },

        getType: function () {
            this.centerType = !this.centerType
        },

        getTypeItem: function (i, item) {
            this.centerType = !this.centerType;
            this.centerTypeName = item.center_category_name;
            this.center_category_id = item.center_category_id;
        },

        setSheet4CourseName(courseName) {
            const name = courseName || (this.courseList[0] && this.courseList[0].master_course_name) || ''
            if (!name) return
            if (this.optionsChart && this.optionsChart.title) {
                this.optionsChart = {
                    ...this.optionsChart,
                    title: {
                        ...this.optionsChart.title,
                        text: 'Total Number of ' + name + ' Students'
                    }
                }
            }
            if (Array.isArray(this.seriesChart)) {
                this.seriesChart = this.seriesChart.map((series, index) => {
                    if (index === 0) return { ...series, name: 'Total ' + name + ' Students' }
                    if (index === 1) return { ...series, name: 'Average Number of ' + name + ' Students Within the Group' }
                    return series
                })
            }
        },
        async changeSheet4Data(item) {
            let loader = this.$loading.show({})
            const course = item || this.courseList[0] || {}
            const sheetFourParams = {
                center_id: this.center_id,
                year: this.year,
                month: this.month,
                singleTypeId: this.singleTypeId,
                token: this.token,
                center_category_id: this.center_category_id,
                master_course_id: course.master_course_id,
            }
            const data = (await this.fetchData(this.api + 'getReportSheet4', sheetFourParams)).data
            this.processAndSortData(data)
            await this.$axios.get("./chartsData.json").then(res => {
                this.optionsChart = res.data.apexChart.optionsChart
                this.seriesChart = res.data.apexChart.seriesChart
                this.seriesChart[0].data = this.total_num
                this.seriesChart[1].data = this.average_num
                this.optionsChart.labels = this.time_num
                this.setSheet4CourseName(course.master_course_name)
                loader.hide()
            })

        },






        // 图5柱状折线单独渲染的代码
        async changeSheet5Data(year, month) {
            let loader = this.$loading.show({})
            const sheetFiveParams = {
                center_id: this.center_id,
                year: year,
                month: month.cn,
                singleTypeId: this.singleTypeId,
                token: this.token,
                center_category_id: this.center_category_id
            }
            // 这里是请求对应接口的代码我想问的是请求返回带年月吗
            const data = (await this.fetchData(this.api + 'getReportSheet5', sheetFiveParams)).data
            console.log(data)
            // 这里
            this.processAndSortRevenueData(data)
            // 这里是渲染那个表的代码一一什么对应，看这里
            await this.$axios.get("./chartsData.json").then(res => {
                this.seriesRevenue = res.data.apexRevenue.seriesRevenue
                this.optionsRevenue = res.data.apexRevenue.optionsRevenue
                this.seriesRevenue[1].data = this.average_revenue
                this.seriesRevenue[0].data = this.total_revenue
                this.optionsRevenue.labels = this.time_revenue
                loader.hide()
            })
        },








        async changeSheet6Data(year, month) {
            let loader = this.$loading.show({})
            const sheetSixParams = {
                center_id: this.center_id,
                year: year,
                month: month.cn,
                singleTypeId: this.singleTypeId,
                token: this.token,
                center_category_id: this.center_category_id
            }
            const data = (await this.fetchData(this.api + 'getReportSheet6', sheetSixParams)).data
            this.processAndSortTNSData(data)
            await this.$axios.get("./chartsData.json").then(res => {
                this.optionsArea = res.data.apexArea.optionsArea;
                this.seriesArea = res.data.apexArea.seriesArea;
                this.seriesArea[1].data = this.average_total_number_of_student;
                this.seriesArea[1].name = this.average_name;
                this.seriesArea[0].data = this.total_number_of_student;
                this.seriesArea[0].name = this.total_name;
                this.optionsArea.xaxis.categories = this.time_number;
                loader.hide()
            })
        },
        async changeSheet7Data(year, month) {
            let loader = this.$loading.show({})
            const sheetSevenParams = {
                center_id: this.center_id,
                year: year,
                month: month.cn,
                singleTypeId: this.singleTypeId,
                token: this.token,
                center_category_id: this.center_category_id
            }
            const data = (await this.fetchData(this.api + 'getReportSheet7', sheetSevenParams)).data
            this.processAndSortTNsData(data)
            await this.$axios.get("./chartsData.json").then(res => {
                this.optionsTooltips = res.data.apexTooltips.optionsTooltips;
                this.seriesTooltips = res.data.apexTooltips.seriesTooltips;
                this.seriesTooltips[1].data = this.average_total_enrollments;
                this.seriesTooltips[0].data = this.total_enrollments;
                this.optionsTooltips.xaxis.categories = this.time_enrollments;
                loader.hide()
            })
        },
        async changeRetentionData(year, month) {
            let loader = this.$loading.show({})
            const RetentionParams = {
                center_id: this.center_id,
                year: year,
                month: month.cn,
                singleTypeId: this.singleTypeId,
                token: this.token,
                center_category_id: this.center_category_id
            }
            const data = (await this.fetchData(this.api + 'getRetentionRate', RetentionParams)).data
            this.processAndSortRetentionData(data)
            await this.$axios.get("./chartsData.json").then(res => {
                this.optionsPros = res.data.apexPros.optionsPros;
                this.seriesPros = res.data.apexPros.seriesPros;
                this.seriesPros[0].data = this.retenstion_rate;
                this.seriesPros[1].data = this.drop_out_rate;
                this.optionsPros.xaxis.categories = this.rate_time;
                this.setRetentionPercentLabels();
                loader.hide()
            })
        }
    },
}
</script>
<style>
.app-content .apexcharts-legend.apx-legend-position-right {
    /*display: flex;*/
    /*justify-content: space-evenly;*/
    bottom: 10px;
    margin-right: 30px;
}

.app-content .apexcharts-toolbar {
    display: none;
}

.app-content .hiden_in [rel~="1"] .apexcharts-yaxis-texts-g,
.app-content .hiden_in [rel~="1"] .apexcharts-yaxis-title {
    display: none;
}

/*.app-content .apexcharts-graphical .apexcharts-xaxis .apexcharts-text  tspan {*/
/*font-size: 9px;*/
/*}*/

.app-content .hiden_in .apexcharts-inner .apexcharts-line-series {
    display: none;
}

.app-content .SrcItem01 .apexcharts-graphical .apexcharts-xaxis {
    opacity: 0;
}

.app-content .SrcItem01 .title_box {
    position: absolute;
    bottom: 11%;
    left: 3.3%;
    width: 95.4%;
    /*background: red;*/
    display: flex;
}

.app-content .SrcItem01 .title_box .title_item01 {
    width: 100%;
    text-align: center;
    color: rgb(55, 61, 63);
    font-size: 12px;
    font-weight: 400;
    font-family: Helvetica, Arial, sans-serif;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}

.app-content .SrcItem01 .title_box .title_item01 .title_block {
    position: absolute;
    top: 110%;
    background: white;
    padding: 0.15% 0.25%;
    border: 2px solid rgb(0 0 0 / 10%);
    box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
}


.app-content .now_box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 1%;
}

.app-content .confirm-box {
    display: flex;
    align-items: self-end;
    margin-left: 5%;
}

.app-content .confirm-box .confirm-btn {
    color: white;
    font-size: 18px;
    font-weight: bold;
    width: 100%;
    height: 60%;
    background: darkorange;
    border-radius: 5px;
    border: antiquewhite;
    box-shadow: 0px 0px 5px 0px darkorange;
}

.app-content .now_box .topT .apexcharts-yaxis,
.app-content .now_box .topT .apexcharts-xaxis,
.app-content .now_box .topT .apexcharts-grid,
.app-content .now_box .topT .apexcharts-xaxis-tick,
.app-content .now_box .topT .apexcharts-canvas .apexcharts-xaxistooltip.apexcharts-theme-light,
.app-content .now_box .topT .apexcharts-grid-borders {
    display: none;
}

.app-content .now_box .topT .apexcharts-xaxis-inversed {
    display: block;
}

.app-content .Src-Box {
    position: relative;
    width: 15%;
}

.app-content .topT {
    height: 300px;
    margin: 1.2rem;
    border: 0;
    background: #fff;
    border-radius: 0.5rem;
    box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
    -webkit-transition: all .3s ease-in-out;
    padding: 0px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.app-content .topT .mon_sice {
    position: absolute;
    top: 13%;
    left: 10%;
    font-size: 48px;
    font-weight: bolder;
}

.app-content .topT .mon_span {
    position: absolute;
    top: 33%;
    left: 15%;
    font-size: 24px;
    color: red;
    font-weight: bold;
}

.app-content .topT .now_time {
    position: absolute;
    top: -8%;
    left: 0%;
    color: red;
    font-family: inherit;
    font-size: 17px;
    width: max-content;
}

.app-content .topT #chart1 {
    //width: 126.5%;
    //margin-left: -19%;
    //margin-bottom: -13%;
    width: 100%;
    margin-bottom: -11%;
}

.app-content .topT #chart2 {
    //width: 120%;
    //margin-left: -12.5%;
    //margin-bottom: -12.77%;
    width: 100%;
    margin-bottom: -11%;
}

.app-content .topT #chart3 {
    //width: 125%;
    //margin-left: -17.7%;
    //margin-bottom: -13%;
    width: 100%;
    margin-bottom: -11%;
}

.app-content .Src-Box .title-box {
    position: absolute;
    top: -13%;
    left: -2%;
    z-index: inherit;
    background: white;
    width: max-content;
    padding: 0 5%;
    border-radius: 30px;
    height: 45%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
}

.app-content .Src-Box .title-box::before {
    content: '';
    position: absolute;
    left: 45%;
    bottom: -30%;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid white;
    box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
}

.app-content .Src-Box .Filter-Box > div,
.app-content .Src-Box .Src-Name-Box .src-name:hover {
    cursor: pointer;
}

.app-content .title_item {
    width: 100%;
    color: red;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 1%;
}

.app-content .Src-Box .Src-Name-Box {
    display: flex;
    flex-direction: row;
    padding: 10px 5px;
    /*border: 1px solid black;*/
    width: 100%;
    justify-content: space-between;
    align-items: center;
    background: white;
    box-shadow: 0px 0px 5px 0px #d1cece;
}

.app-content .Src-Box .Src-Name-Box .src-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.app-content .Data-Box {
    width: 10%;
    margin-left: 5%;
}

.app-content .Data-Box01 {
    margin-left: 5%;
}

.app-content .Type-Box {
    margin-left: 0%;
}

.app-content .Name-Box {
    width: 13%;
    margin-left: 5%;
}

.app-content .Src-Box .Src-Name-Box img {
    width: 20px;
    height: 20px;
}

.app-content .Src-Box .Filter-Box {
    display: flex;
    flex-direction: column;
    padding: 10px 0px;
    /*border: 1px solid black;*/
    border-top: none;
    width: 100%;
    position: absolute;
    left: 0;
    z-index: 10000;
    background: white;
    box-shadow: 5px 5px 10px -4px #d1cece;
    height: 150px;
    overflow: hidden;
    overflow-y: scroll;
}

.app-content .Src-Box .Filter-Box01 {
    height: 180px;
}

.app-content .Src-Box .Filter-Box02 {
    height: 100px;
}

.app-content .Src-Box .Filter-Box::-webkit-scrollbar {
    display: none;
}

.app-content .Src-Box .Filter-Box > div {
    padding: 10px 0px 10px 5px;
}

.app-content .Src-Box .Filter-Box > div:hover {
    background-color: #ccc;
    color: white;
}

.app-content .SrcBox {
    z-index: 1000;
    opacity: 0.99;
}

/*.app-content .box {*/
/*margin-top: 5rem;*/
/*}*/
.app-content .SrcItem .b_card .course {
    font-size: 16px;
    font-weight: bold;
    /*margin-bottom: 2%;*/
}

.app-content .SrcItem .b_card {
    height: 500px;
}

.app-content .SrcItem .No_data {
    position: absolute;
    width: 96.5%;
    height: 93%;
    background: white;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
}

.app-content .now_box .topT .No_data {
    position: absolute;
    width: 102%;
    height: 100%;
    z-index: 9;
    left: -1%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;

}

.app-content .now_box .topT .No_data .No_item,
.app-content .SrcItem .No_data .No_item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.app-content .now_box .topT .No_data p,
.app-content .SrcItem .No_data .No_item p {
    color: #8a8a8a;
    font-size: 16px;
    text-align: center;
    margin-top: 5%;
    font-weight: bold;
    font-family: initial;
}

.app-content .now_box .topT .No_data img,
.app-content .SrcItem .No_data .No_item img {
    width: 50%;
}

.app-content .hide_in01 {
    position: absolute;
    top: 0;
    right: 0px;
    width: 9%;
    height: 100%;
    background: white;
}

.app-content .hide_in02 {
    width: 11%;
}

.app-content .ProsBox .apx-legend-position-right {
    right: -20px !important;
    top: 42% !important;
}
</style>
<style scoped lang="scss">
::v-deep .SrcItem {
    position: relative;

    .chart_with_menu {
        position: relative;

        > .card .card-body {
            padding-right: 42px;
        }
    }

    .chart_menu_tight > .card .card-body {
        padding-right: 24px;
    }

    .chart_menu_wide > .card .card-body {
        padding-right: 0;
    }

    .chart_menu_inset > .card .card-body {
        padding-right: 90px;
    }

    .right_drop_menu {
        position: absolute;
        top: 14px;
        right: 16px;
        z-index: 3;
        width: 100px;
        cursor: pointer;
        opacity: 1;

        .drop_item {
            margin-bottom: 10px;
            position: relative;

            .src {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 5px;
                background: #f7f7f7;
                width: 95px;

                img {
                    width: 15px;
                    flex-shrink: 0;
                }

                .course_name {
                    flex: 1;
                    min-width: 0;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    word-break: break-word;
                    line-height: 16px;
                    max-height: 32px;
                }
            }

            .filter_box {
                position: absolute;
                z-index: 10;
                display: flex;
                flex-direction: column;
                //padding: 5px;
                border-top: none;
                width: 100%;
                left: 0;
                background: white;
                box-shadow: 5px 5px 10px -4px #d1cece;
                height: 150px;
                overflow: hidden;
                overflow-y: scroll;

                > div {
                    padding: 5px;

                    &:hover {
                        background-color: #ccc;
                        color: white;
                    }
                }

                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }

        .confirm_btn {
            text-align: center;
            font-size: 12px;
            font-weight: bold;
            background: darkorange;
            width: 80%;
            color: white;
            border-radius: 5px;
            box-shadow: 0 0 5px 0 darkorange;
            border: antiquewhite;
            padding: 5px 0;
        }
    }

    @media (max-width: 768px) {
        .chart_with_menu > .card .card-body {
            padding-right: 28px;
        }

        .chart_menu_tight > .card .card-body {
            padding-right: 16px;
        }

        .chart_menu_wide > .card .card-body {
            padding-right: 100px;
        }

        .chart_menu_inset > .card .card-body {
            padding-right: 64px;
        }

        .right_drop_menu {
            top: 8px;
            right: 8px;
            width: 84px;

            .drop_item {
                margin-bottom: 6px;

                .src {
                    width: 80px;
                    padding: 4px;

                    .course_name {
                        font-size: 12px;
                        line-height: 14px;
                        max-height: 28px;
                    }
                }

                .filter_box {
                    left: auto;
                    right: 0;
                    width: 168px;
                    max-width: 70vw;
                    height: 120px;
                }
            }

            .confirm_btn {
                width: 90%;
                font-size: 12px;
                padding: 4px 0;
            }
        }
    }
}
</style>


